import { BaseOrderDirectionEnum } from 'base';

export const BaseCustomerInquiryOffersFiltersOptionsConst = [
  { name: 'name', orderKey: 'profileLastName', orderDirection: BaseOrderDirectionEnum.asc },
  { name: 'qualifications.singular', orderKey: 'qualificationName', orderDirection: BaseOrderDirectionEnum.asc },
  { name: 'price.singular', orderKey: 'price', orderDirection: BaseOrderDirectionEnum.asc },
  { name: 'action.defaultSorting', orderKey: '', orderDirection: undefined },
];

export const BaseCustomerInquiryExperienceOptionsConst = [
  { value: true, label: 'filter.withExperience' },
  { value: false, label: 'filter.noExperience' },
];
